import { createSlice } from '@reduxjs/toolkit';

const entryState = createSlice({
  name: 'entryState',
  initialState: {},
  reducers: {
    setSelectedCategory(state, action) {
      return action.payload;
    }
  }
});

export const { setSelectedCategory } = entryState.actions;
export default entryState.reducer;